import { useState } from "react";
import { HeroLayoutProps } from "./HeroProps";
import { KmsTypeComponent, KmsTypeHeroProps } from "@kaltura/mediaspace-shared-types";
import { Converting } from "./converting/Converting";
import { PlayerNotSupported } from "./player-not-supported/PlayerNotSupported";
import { getComponentFromPath } from "@kaltura/mediaspace-shared-utils";

export interface HeroComponentProps extends HeroLayoutProps, KmsTypeComponent {
    props: KmsTypeHeroProps;
    isReadOnly?: boolean;
}

/**
 * media-page Hero Component - renders the Hero component, or the status components
 */
export function Hero(props: HeroComponentProps) {
    const { component, props: componentProps, collapse, onToggleCollapse, onEntryChange, isReadOnly = false } = props;

    const { playerIsV7 = true, topComponents = [] } = componentProps;

    const [converting, setConverting] = useState(componentProps.converting ?? false);

    const HeroComponent = getComponentFromPath(component);

    if (!playerIsV7) {
        return <PlayerNotSupported {...componentProps} />;
    }

    return (
        <>
            {topComponents.map((topComponent, index) => {
                const { component, props } = topComponent;
                const Component = getComponentFromPath(component);
                return <Component key={index} {...props} />;
            })}
            {converting && <Converting {...componentProps} onConversionEnd={() => setConverting(false)} />}
            {!converting && (
                <HeroComponent
                    {...componentProps}
                    collapse={collapse}
                    onToggleCollapse={onToggleCollapse}
                    onEntryChange={onEntryChange}
                    isReadOnly={isReadOnly}
                />
            )}
        </>
    );
}

export default Hero;
